import React, { useEffect } from 'react'
import Sidenav from 'src/components/features/Sidenav'
import Content from './Content'
import MobileFooter from 'src/components/features/MobileFooter'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useScreenTime from 'src/hooks/useScreenTime'
import { savePendingRedirect } from 'src/hooks/usePendingRedirect'

const RoleLayout = ({ allowedProfile, routes }) => {
  const navigate = useNavigate()
  const profileType = useSelector((state) => state.userDetails?.[0]?.profileType)
  const token = window.localStorage.getItem('token')
  useScreenTime()

  useEffect(() => {
    if (!token) {
      savePendingRedirect()
      navigate('/')
      return
    }

    if (!profileType) return

    if (profileType !== allowedProfile) {
      switch (profileType) {
        case 'Student':
          navigate('/student')
          break
        case 'Teacher':
          navigate('/teacher')
          break
        case 'Admin':
          navigate('/admin')
          break
        case 'Verifier':
          navigate('/verifier')
          break
        default:
          navigate('/')
      }
    }
  }, [token, profileType, allowedProfile, navigate])

  return (
    <>
      <Sidenav />
      <section className="ps-0 ps-md-80 flex-column min-vh-100 align-content-center">
        <Content routes={routes} />
        <div className="mt-auto d-block d-sm-none w-100">
          <MobileFooter />
        </div>
      </section>
    </>
  )
}

export default RoleLayout
